import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  CircularProgress
} from '@mui/material'
import ApiConstants from '../config.json'
import { login, loginSuccess } from '../redux/Login/loginActions'
import { postRequest } from '../globalhelper/helper'
import { hideLoader, showLoader } from '../redux/Common/commonActions'

const ORGDialogbox = ({ open, onClose }) => {
  const dispatch = useDispatch()
  const organizations = useSelector(state => state.common.organizations) || []

  const [localLoading, setLocalLoading] = useState(false)

  const selectOrganization = async (tenantId, Image) => {
    try {
      setLocalLoading(true)
      console.log(organizations);
      dispatch(showLoader());
      localStorage.setItem('tenant_id', tenantId)
      localStorage.setItem('Image', Image)
      const formData = { tenantId }
      await postRequest("api/auth/getUserProfile", formData)
        .then((data) => {
          if (data.type === "success") {
            localStorage.setItem("go_to_landing_page", "1");
            localStorage.setItem("organization", data.res.data.USR_Organization);
            dispatch(loginSuccess(data.res.data));
          }
        })

      // If not on login page, reload to refresh dashboard context
      if (window.location.pathname !== '/login') {
        window.location.reload()
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLocalLoading(false)
      dispatch(hideLoader());
      onClose()
    }
  }
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minWidth: { xs: '90%', sm: '450px' },
          borderRadius: '16px',
          boxShadow: '0 25px 50px -12px rgba(0,0,0,0.3)',
          p: 1
        }
      }}
    >
      {localLoading && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: 'rgba(255, 255, 255, 0.7)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(2px)',
            borderRadius: '16px'
          }}
        >
          <CircularProgress size={48} thickness={4.5} sx={{ color: '#1e40af', mb: 2 }} />
          <Typography variant="body2" sx={{ fontWeight: 700, color: '#1e40af' }}>
            Switching Context...
          </Typography>
        </Box>
      )}
      <DialogTitle sx={{ p: 3, pb: 1.5, fontSize: '1.5rem', fontWeight: 800, color: '#1e40af' }}>
        Select Organization
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3.5, fontWeight: 500 }}>
          Please choose an organization to switch your current workspace context.
        </Typography>
        <Grid container spacing={2.5}>
          {organizations.map((org) => (
            <Grid item xs={6} sm={4} key={org.Tenant_ID}>
              <Box
                onClick={() => selectOrganization(org.Tenant_ID, org.Image)}
                sx={{
                  p: 2.5,
                  border: '1px solid #f1f5f9',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  textAlign: 'center',
                  transition: 'all 0.3s',
                  '&:hover': {
                    bgcolor: '#f8faff',
                    borderColor: '#1e40af',
                    boxShadow: '0 8px 16px -4px rgba(30, 64, 175, 0.1)',
                    transform: 'translateY(-4px)'
                  }
                }}
              >
                <img
                  src={`${ApiConstants.externals.serverUrl}api/user/getTenantAvatar?fileName=${org.Image}`}
                  alt={org.Organisation}
                  style={{ height: 44, width: 44, objectFit: 'contain' }}
                />
                <Typography variant="caption" sx={{ fontWeight: 800, display: 'block', mt: 2, color: 'text.primary' }}>
                  {org.Organisation}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button onClick={onClose} sx={{ color: 'text.secondary', fontWeight: 600 }}>
          Cancel Selection
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ORGDialogbox
